import { Component } from '@angular/core';
import * as allSiteData from './allsites.json';

@Component({
  selector: 'app-applinks',
  templateUrl: './applinks.component.html',
  styleUrls: ['./applinks.component.css']
})
export class AppLinksComponent {
 
  allSites = (allSiteData as any).default;
  projects = ["CamAcct", "Project", "Connect", "Service","BudgetTool","Contract Management"];
  env = 'QA';
}
